import { Component, OnDestroy, OnInit, SecurityContext } from '@angular/core';
import { ZohoReportService } from '../core/services/zoho-report.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { AuthenticationService } from 'src/sb-tools/typescript/authentication/authentication.service';
import { TranslateModule } from '@ngx-translate/core';
import { SettingsMenuComponent } from '../../sb-modules/Frontend-Settings-Menu-Module/settings-menu.component';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    providers: [ZohoReportService],
    imports: [TranslateModule, SettingsMenuComponent],
})
export class ReportsComponent implements OnInit, OnDestroy {
    public dashboardUrl: string;
    public dashboardUrlSanitized: SafeResourceUrl;

    private unsubscriber = new Subject<void>();

    constructor(
        public authenticationService: AuthenticationService,
        public commonDataService: CommonDataService,
        private zohoReportService: ZohoReportService,
        private domSanitizer: DomSanitizer,
    ) {}

    ngOnInit() {
        this.zohoReportService
            .getDashboardUrl()
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((data: string) => {
                this.dashboardUrl = data;
                this.dashboardUrlSanitized = this.domSanitizer.bypassSecurityTrustResourceUrl(
                    this.domSanitizer.sanitize(SecurityContext.URL, this.dashboardUrl),
                );
            });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
